import React, { useState } from "react";
import { Helmet } from "react-helmet";
import BreadCrumb from "../../Header/SecondHeader";
import trans from "../../../utils";
import POIsWorkloadHeader from "./POIsWorkloadHeader";
import HeatmapMap from "./WorkloadHeatMap";

export default function POIsWorkload() {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  return (
    <div>
      <Helmet>
        <title>POIs HeatMap</title>
        <meta name="description" content="POIs HeatMap" />
      </Helmet>
      <BreadCrumb title={trans("Point Of Interest")} />
      <POIsWorkloadHeader setStartDate={setStartDate} setEndDate={setEndDate} />
      <HeatmapMap startDate={startDate} endDate={endDate} />
    </div>
  );
}
